import { CALCULATION_TYPE } from 'domains/seller-product-commission/constants'
import * as Yup from 'yup'

const commissionCreateFormSchema = Yup.object().shape(
  {
    name           : Yup.string().required(),
    absolute_value : Yup.number()
      .when('calculation_type', {
        is   : (value) => value === CALCULATION_TYPE['ABSOLUTE'],
        then : Yup.number().required(
          'Absolute Value is Required'
        ),
        otherwise: Yup.number()
      }),
    percentage: Yup.number()
      .when('calculation_type', {
        is   : (value) => value === CALCULATION_TYPE['PERCENTAGE'],
        then : Yup.number()
          .max(100)
          .required(
            'Percentage is Required'
          ),
        otherwise: Yup.number()
      }),
    contract_id      : Yup.string().required(),
    calculation_type : Yup.string().required(),
    payable_to       : Yup.string().required(),
    price_from       : Yup.number().required(),
    price_to         : Yup.number().required()
  }
)

export default commissionCreateFormSchema
